import { load, getAttachmentFromAPI, post } from 'src/helpers/apiHelper';

export function loadAgreement(id, onSuccess, onError) {
  return load(`/api/agreement/${id}`, () => {}, onSuccess, onError);
}

export function loadClaimAgreements(claimId, onSuccess, onError) {
  return load(`/api/agreement?claimId=${claimId}`, () => {}, onSuccess, onError);
}

export function loadAgreementPdf(filename, agreementId) {
  return getAttachmentFromAPI(filename, `/api/agreement/${agreementId}/attachment`);
}

export function loadActiveAgreements(onSuccess, onError) {
  return load(`/api/agreement/all`, () => {}, onSuccess, onError);
}

export function approveCounterOffer(agreementId, onSuccess, onError) {
  return post(`/api/Agreement/approve-counter-offer`, { agreementId }, () => {}, onSuccess, onError);
}

export function rejectCounterOffer(agreementId, onSuccess, onError) {
  return post(
    `/api/Agreement/reject-counter-offer`,
    { agreementId, rejectionReason: '' },
    () => {},
    onSuccess,
    onError
  );
}

export function loadAlterationPlan(agreementId, onSuccess, onError) {
  return load(`/api/agreement/alteration-plan/${agreementId}`, () => {}, onSuccess, onError);
}

export function alterAgreement(agreementId, onSuccess, onError) {
  return post(`/api/agreement/alter/${agreementId}`, {}, () => {}, onSuccess, onError);
}
